export const translateAppliance = (value: string) => {
    switch (value) {
        case 'AlwaysOn': {
            return 'Grundlast';
        }
        case 'Refrigeration': {
            return 'Kühlung';
        }
        case 'SpaceHeating': {
            return 'Nachtspeicherofen';
        }
        case 'WaterHeating': {
            return 'Durchlauferhitzer';
        }
        case 'Cooking': {
            return 'Kochen';
        }
        case 'Laundry': {
            return 'Reinigen & Trocknen';
        }
        case 'Lighting': {
            return 'Beleuchtung';
        }
        case 'Entertainment': {
            return 'Unterhaltung';
        }
        case 'ElectricVehicle': {
            return 'E-Auto';
        }
        case 'PoolOrSauna': {
            return 'Pool & Sauna';
        }
        case 'Other': {
            return 'Sonstige';
        }
        case 'DishWasher': {
            return 'Spülmaschine';
        }
        case 'Dryer': {
            return 'Trockner';
        }
        case 'WashingMachine': {
            return 'Waschmaschine';
        }
        default: {
            return value;
        }
    }
};

export interface AppliancesDiagramCallout {
    label: string;
    value: string;
    image: string;
    applianceProfileComplete: boolean;
    color: string;
}
